/**
 * Loop widget overrides. The app owns the markup, so the theme changes it here.
 *
 *   ShLoopWidget.add('my-override', function (widget) { ... });
 *
 * Every override runs after each re-render, so keep it safe to run many times.
 */
window.ShLoopWidget = (function () {
  var WIDGET_SELECTOR = '.loop-widget-container';
  var overrides = [];
  var scheduled = false;

  function add(name, callback) {
    overrides.push({ name: name, callback: callback });
    run();
  }

  /* Runs the callback one time for each element. */
  function once(element, flag, callback) {
    var key = 'shLoop' + flag;
    if (element.dataset[key] === 'true') return false;
    element.dataset[key] = 'true';
    callback(element);
    return true;
  }

  /* Runs every override one time per frame. */
  function run() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      var widgets = document.querySelectorAll(WIDGET_SELECTOR);

      for (var i = 0; i < widgets.length; i++) {
        for (var j = 0; j < overrides.length; j++) {
          try {
            overrides[j].callback(widgets[i]);
          } catch (error) {
            console.error('[sh-loop-widget] ' + overrides[j].name + ' failed', error);
          }
        }
      }
    });
  }

  /* The variant that the customer sees now. */
  function variant(widget) {
    var input = (widget.closest('form') || document).querySelector('[name="id"]');
    return input ? input.value : '';
  }

  /* UVP and plans of the current variant, or null.
     sh-loop-plans.liquid prints the map. */
  var allVariants = null;

  function entry(widget) {
    if (!allVariants) {
      allVariants = {};
      var data = document.getElementById('sh-loop-plans');

      if (data) {
        try {
          allVariants = JSON.parse(data.textContent);
        } catch (error) {
          console.error('[sh-loop-widget] the plan map is not valid JSON', error);
        }
      }
    }

    return allVariants[variant(widget)] || null;
  }

  /* Unit price and discount of every plan of the current variant, or null. */
  function plans(widget) {
    var record = entry(widget);
    return (record && record.plans) || null;
  }

  /* UVP (compare_at_price) of one unit of the current variant in cents,
     or 0 when the variant has none. */
  function uvp(widget) {
    var record = entry(widget);
    return (record && record.uvp) || 0;
  }

  function quantityBlock(widget) {
    var form = widget.closest('form') || document;
    var block = form.querySelector('sh-quantity-upsell') || document.querySelector('sh-quantity-upsell');

    if (!block || typeof block.getSelectedOption !== 'function') return null;

    once(block, 'Quantity', function () {
      block.addEventListener('sectionheroes:qu:changed', run);
    });

    return block;
  }

  function step(option, index) {
    var discount = (option && option.discount) || {};

    return {
      index: index,
      quantity: Number(option && option.quantity) || 1,
      type: discount.type,
      value: parseFloat(discount.value) || 0
    };
  }

  /* The quantity tile that the customer selected, from the Section Heroes
     block: {index, quantity, type, value}. */
  function tier(widget) {
    var block = quantityBlock(widget);
    if (!block) return null;

    var selected = block.getSelectedOption();
    var option = selected && block.options && block.options[selected.optionIndex];
    if (!option) return null;

    return step(option, selected.optionIndex);
  }

  /* Every quantity tile. The saving badge needs the whole list. */
  function tiers(widget) {
    var block = quantityBlock(widget);
    var options = (block && block.options) || [];
    var list = [];

    for (var i = 0; i < options.length; i++) {
      list.push(step(options[i], i));
    }

    return list.length ? list : [step(null, 0)];
  }

  /* Tile 1 takes the first plan, tile 2 the second, and so on. A tile without
     a plan of its own takes the last plan. */
  function planFor(select, index) {
    if (!select || !select.options.length) return '';
    return select.options[Math.min(index || 0, select.options.length - 1)].value;
  }

  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });

  return {
    add: add,
    run: run,
    once: once,
    variant: variant,
    plans: plans,
    uvp: uvp,
    tier: tier,
    tiers: tiers,
    planFor: planFor,
    selector: WIDGET_SELECTOR
  };
})();

/* Override 1: move the tooltip below the dropdown, above the benefit rows. */
ShLoopWidget.add('tooltip-position', function (widget) {
  var tooltip = widget.querySelector('.loop-widget-tooltip-container');
  var description = widget.querySelector('.loop-widget-sp-selector-description-wrapper');

  if (!tooltip || !description || tooltip.parentNode === description.parentNode) return;

  description.parentNode.insertBefore(tooltip, description);
});

/* Override 2: preselect the plan of the quantity tile and badge it. A native
   option cannot hold a badge, so the theme draws the text and the badge over
   the field. */
(function () {
  var BADGE_TEXT = 'Empfohlen';

  function field(container) {
    var overlay = container.querySelector('.sh-loop-field');

    if (!overlay) {
      overlay = document.createElement('span');
      overlay.className = 'sh-loop-field';
      overlay.innerHTML =
        '<span class="sh-loop-field__text"></span>' +
        '<span class="sh-loop-field__badge">' + BADGE_TEXT + '</span>';
      container.appendChild(overlay);
      container.classList.add('sh-has-field');
    }

    return overlay;
  }

  ShLoopWidget.add('recommended-plan', function (widget) {
    var select = widget.querySelector('.loop-widget-sp-selector');
    if (!select) return;

    var step = ShLoopWidget.tier(widget);
    var current = ShLoopWidget.variant(widget) + ':' + (step ? step.index : 0);
    var plan = ShLoopWidget.planFor(select, step ? step.index : 0);

    /* The observer does not see a new value, so the select reports it. */
    ShLoopWidget.once(select, 'PlanChange', function () {
      select.addEventListener('change', function (event) {
        if (event.isTrusted) select.dataset.shLoopChosen = 'true';
        ShLoopWidget.run();
      });
    });

    /* A new tile or a new variant clears the choice of the customer, so the
       tile plan always wins after a tile click. */
    if (select.dataset.shLoopTier !== current) {
      select.dataset.shLoopTier = current;
      select.dataset.shLoopChosen = 'false';
    }

    /* The change event also selects the purchase option, so the preselect waits
       until the customer opens the subscription option. */
    var box = select.closest('.loop-widget-purchase-option');

    if (
      plan &&
      (!box || box.classList.contains('loop-widget-purchase-option-selected')) &&
      select.value !== plan &&
      select.dataset.shLoopChosen !== 'true'
    ) {
      select.value = plan;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var option = select.options[select.selectedIndex];
    var overlay = field(select.parentNode);

    overlay.querySelector('.sh-loop-field__text').textContent = option ? option.text : '';
    overlay.classList.toggle('sh-loop-field--recommended', Boolean(plan) && select.value === plan);
  });
})();

/* Override 3: show the price for the selected quantity tile.
   The app prints the price of one unit. The checkout takes the plan discount
   first, then the tile discount, and it rounds each unit down. The cart of
   3 x "alle 6 Monate" proves it: 24,99 -> 21,24 -> 19,11 -> 57,33. */
(function () {
  var POPULAR_TEXT = 'Spare bis zu {percent}%';
  var UNIT_TEXT = '{price} / Stück';

  /* Splits "1.234,56 €" into the amount and the way the shop writes it. */
  function money(text) {
    var digits = text.match(/\d[\d., \s]*\d|\d/);
    if (!digits) return null;

    var raw = digits[0];
    var decimal = /[.,]\d{2}$/.test(raw) ? raw.charAt(raw.length - 3) : ',';
    var group = decimal === ',' ? '.' : ',';
    var plain = raw.split(group).join('').replace(/[ \s]/g, '').replace(decimal, '.');

    return {
      cents: Math.round(parseFloat(plain) * 100),
      write: function (value) {
        var parts = (value / 100).toFixed(2).split('.');
        var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group);
        return text.replace(raw, whole + decimal + parts[1]);
      }
    };
  }

  function unitAfterTier(cents, step) {
    if (step.type === 'percentage' && step.value > 0) {
      return Math.floor(cents * (1 - step.value / 100));
    }

    if (step.type === 'fixed_amount' && step.value > 0) {
      return Math.max(0, Math.floor(cents - (step.value * 100) / step.quantity));
    }

    return cents;
  }

  /* The app rewrites the price on each render, so the last text that the
     override did not write itself counts as the price of one unit. */
  function source(element) {
    if (element.dataset.shLoopShown !== element.textContent) {
      element.dataset.shLoopUnit = element.textContent;
    }

    return money(element.dataset.shLoopUnit);
  }

  function write(element, text) {
    if (element.textContent === text) return;
    element.textContent = text;
    element.dataset.shLoopShown = text;
  }

  /* The plan whose price the box must show: the plan in the select once the
     customer opens the option, else the plan of the quantity tile. */
  function chosenPlan(box, record, step) {
    if (!record) return null;
    if (box.classList.contains('loop-widget-purchase-option-onetime')) return null;

    var select = box.querySelector('.loop-widget-sp-selector');
    if (!select) return null;

    var follow =
      box.classList.contains('loop-widget-purchase-option-selected') ||
      select.dataset.shLoopChosen === 'true';
    var id = follow && select.value
      ? select.value
      : ShLoopWidget.planFor(select, step.index);

    return record[id] || null;
  }

  /* The app badge shows a discount. The design shows the price of one unit.
     An empty badge hides itself, see the :empty rule in the CSS. */
  function badge(box, text) {
    var element = box.querySelector('.loop-widget-purchase-option-discount-badge');
    if (element) write(element, text);
  }

  /* A USP row that holds {percent} shows the discount of the plan in the box.
     The token marks the row, because the app strips a data attribute from the
     description field. */
  function usp(box, percent) {
    var rows = box.querySelectorAll('.bbb-usp__text');

    for (var i = 0; i < rows.length; i++) {
      var element = rows[i];

      if (element.dataset.shLoopShown !== element.textContent) {
        if (element.textContent.indexOf('{percent}') < 0) continue;
        element.dataset.shLoopTemplate = element.textContent;
      }

      if (!element.dataset.shLoopTemplate) continue;

      write(element, element.dataset.shLoopTemplate.replace('{percent}', percent));
    }
  }

  /* The badge says "up to", so it holds the best saving that the page can
     reach: the largest tile discount together with the largest plan discount,
     against the base of one unit (the UVP, else the one time price). The value
     drops its decimals. */
  function topPercent(record, tiers, base) {
    var best = 0;

    if (!base) return 0;

    for (var id in record) {
      for (var i = 0; i < tiers.length; i++) {
        var unit = unitAfterTier(record[id].price, tiers[i]);
        var percent = (1 - unit / base) * 100;
        if (percent > best) best = percent;
      }
    }

    return Math.floor(best);
  }

  /* The saving badge above the subscription option. */
  function popular(box, percent) {
    var element = box.querySelector('.sh-loop-popular');

    if (!percent) {
      if (element) element.remove();
      return;
    }

    if (!element) {
      element = document.createElement('span');
      element.className = 'sh-loop-popular';
      box.insertBefore(element, box.firstChild);
    }

    var text = POPULAR_TEXT.replace('{percent}', percent);
    if (element.textContent !== text) element.textContent = text;
  }

  /* The struck price of a box: the base of one unit (the UVP, else the one
     time price) for the quantity of the tile. A box that costs the same shows
     no struck price. */
  function struck(price, base, step) {
    var value = money(price.textContent);
    if (!value || !base) return '';

    var total = base * step.quantity;
    return total > value.cents ? value.write(total) : '';
  }

  /* The theme draws the struck price beside the price in every box. */
  function compare(price, text) {
    var element = price.parentNode.querySelector('.sh-loop-compare');

    if (!text) {
      if (element) element.remove();
      return;
    }

    if (!element) {
      element = document.createElement('span');
      element.className = 'sh-loop-compare';
      price.parentNode.insertBefore(element, price);
    }

    if (element.textContent !== text) element.textContent = text;
  }

  /* A one time price with a struck price shows in the red of the plan price.
     The app sets that color, so the theme reads it from the plan box. */
  function sale(onetime, plan, on) {
    var color = on && plan ? getComputedStyle(plan).color : '';
    if (onetime.style.color !== color) onetime.style.color = color;
  }

  ShLoopWidget.add('quantity-price', function (widget) {
    /* A product without quantity tiles keeps one unit and no tile discount. */
    var step = ShLoopWidget.tier(widget) || { index: 0, quantity: 1, type: '', value: 0 };
    var record = ShLoopWidget.plans(widget);
    var uvp = ShLoopWidget.uvp(widget);
    var onetime = widget.querySelector('[id^="loop-widget-purchase-option-price-onetime"]');
    var plain = onetime ? source(onetime) : null;
    /* The base of one unit: the UVP, else the one time price of one unit. */
    var base = plain ? Math.max(uvp, plain.cents) : uvp;
    var best = topPercent(record, ShLoopWidget.tiers(widget), base);
    var boxes = widget.querySelectorAll('.loop-widget-purchase-option');

    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var container = box.querySelector('.loop-widget-purchase-option-price-container');
      if (!container) continue;

      /* The app keeps its own first plan, so the price follows the select.
         Before the customer opens the option, it follows the metafield. */
      var chosen = chosenPlan(box, record, step);
      var parts = container.children;

      for (var j = 0; j < parts.length; j++) {
        if (parts[j].classList.contains('sh-loop-compare')) continue;

        var value = source(parts[j]);
        if (!value) continue;

        /* The final price also takes the tier discount. A struck price from
           the app hides, because the theme draws the UVP itself. */
        if (parts[j].classList.contains('loop-widget-purchase-option-price')) {
          var unit = chosen ? chosen.price : value.cents;
          var each = unitAfterTier(unit, step);

          write(parts[j], value.write(each * step.quantity));

          /* One unit shows the same number as the price, so the badge stays
             empty in that case. The design writes the price without the space
             before the currency, so the badge drops it. */
          var each_text = value.write(each).replace(/ /g, '');

          badge(box, step.quantity > 1 ? UNIT_TEXT.replace('{price}', each_text) : '');
        } else {
          parts[j].style.display = 'none';
        }
      }

      if (!box.classList.contains('loop-widget-purchase-option-onetime')) {
        popular(box, best);
        usp(box, chosen ? chosen.percent : 0);
      }

      var price = box.querySelector('.loop-widget-purchase-option-price');

      if (price) compare(price, struck(price, base, step));
    }

    if (onetime) {
      var plan = widget.querySelector(
        '.loop-widget-purchase-option:not(.loop-widget-purchase-option-onetime) .loop-widget-purchase-option-price'
      );
      sale(onetime, plan, Boolean(onetime.parentNode.querySelector('.sh-loop-compare')));
    }
  });
})();
